import React from "react";
import {
  View,
  StyleSheet,
  Modal,
  ActivityIndicator,
  Image,
  TouchableNativeFeedback,
} from "react-native";
import colors from "@constants/color";
import Text from "@components/AppText";
import { scale, verticalScale } from "@utils/scale";
import { rgba } from "react-native-color-matrix-image-filters";
import MoneyTransferred from "../../assets/svg/WithdrawMoney/MoneyTransferred";
import CloseIcon from "../../assets/svg/CloseIcon";
import { STATE_STATUS } from "../../reducers/actionTypes";
import FetchCMSEntity from "@components/CMS/FetchCMSEntity";
import { useDispatch, useSelector } from "react-redux";

import t from "@constants/localization";
import useCMSEvents from "@hooks/useCMSEvents";

const PATH = "screens/WithdrawMoney/PaymentStatusModal";

const CMS_KEY = "GULLAK_PAGE_SUCCESS";

const CloseIconBtn = ({ onPress }) => (
  <TouchableNativeFeedback onPress={onPress}>
    <View
      style={{
        position: "absolute",
        padding: 5,
        top: 19,
        left: 19,
      }}
    >
      <CloseIcon />
    </View>
  </TouchableNativeFeedback>
);

export default ({
  status,
  resetWithdrawMoney,
  onRequestClose = () => {},
  from = "default",
}) => {
  const appSettings = useSelector((s) => s.configReducer.appSettings);
  const trackEvent = useCMSEvents("walletlanding");
  const { cmsPoweredEntities = {} } = appSettings || {};
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={
        status === STATE_STATUS.CREATING || status === STATE_STATUS.CREATED
      }
      onRequestClose={onRequestClose}
    >
      <View
        style={{
          backgroundColor: colors.white,
          flex: 1,
        }}
      >
        {status === STATE_STATUS.CREATING && (
          <CloseIconBtn onPress={resetWithdrawMoney} />
        )}
        {status === STATE_STATUS.CREATED && (
          <CloseIconBtn onPress={onRequestClose} />
        )}
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {status === STATE_STATUS.CREATED && (
            <>
              <MoneyTransferred />
              <Text
                bold
                mukta
                style={{ fontSize: scale(20), marginTop: verticalScale(24) }}
              >
                {t(`${PATH}/congratulations`)}
              </Text>

              <Text
                mukta
                style={{
                  fontSize: scale(16),
                  color: "rgba(0,0,0,.36)",
                  textAlign: "center",
                  paddingHorizontal: scale(35),
                }}
              >
                {from === "ccfp"
                  ? t(`${PATH}/CFPToBankAcc`)
                  : t(`${PATH}/walletToBankAcc`)}
              </Text>
              <View
                style={{
                  flex: 0.5,
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 20,
                }}
              >
                {cmsPoweredEntities &&
                typeof cmsPoweredEntities === "object" &&
                CMS_KEY in cmsPoweredEntities ? (
                  <FetchCMSEntity
                    trackEvent={trackEvent}
                    id={cmsPoweredEntities[CMS_KEY]}
                    type="PAGE"
                  />
                ) : null}
              </View>
            </>
          )}
          {status === STATE_STATUS.CREATING && (
            <>
              <Image
                source={require("../../assets/svg/WithdrawMoney/TransferringMoney.webp")}
              />

              <View
                style={{
                  width: scale(330),
                  height: verticalScale(95),
                  borderRadius: 5,
                  flexDirection: "row",
                  backgroundColor: "#fff",
                  elevation: 5,
                  marginTop: verticalScale(40),
                  alignItems: "center",
                  paddingHorizontal: scale(20),
                  justifyContent: "flex-start",
                }}
              >
                <ActivityIndicator size="large" color={colors.primary} />
                <View
                  style={{
                    height: "90%",
                    width: scale(220),
                    marginLeft: scale(30),
                  }}
                >
                  <Text bold mukta fontType="head3">
                    {t(`${PATH}/wait`)}
                  </Text>
                  <Text
                    mukta
                    style={{
                      fontSize: 14,
                      flex: 1,
                      color: "rgba(0, 0, 0, 0.36)",
                    }}
                  >
                    {from === "ccfp"
                      ? t(`${PATH}/CFPToBankAccTransferring`)
                      : t(`${PATH}/walletToBankAccTransferring`)}
                  </Text>
                </View>
              </View>
              <View
                style={{
                  flex: 0.5,
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 20,
                }}
              >
                {cmsPoweredEntities &&
                typeof cmsPoweredEntities === "object" &&
                CMS_KEY in cmsPoweredEntities ? (
                  <FetchCMSEntity
                    id={cmsPoweredEntities[CMS_KEY]}
                    type="PAGE"
                  />
                ) : null}
              </View>
            </>
          )}
        </View>
      </View>
    </Modal>
  );
};
